import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth/auth.service';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  isMenuOpen = false;
  isGestionMenuOpen = false;
  canAccessKpi = false;

  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  ngOnInit(): void {
    if(this.authService.isLoggedIn() == false) {
      // location.href = '/login';
    }

    const currentUserId = this.authService.getCurrentUserId();
    const authorizedUserIds = environment.kpiAuthorizedUserIds || [];
    this.canAccessKpi = !!currentUserId && authorizedUserIds.includes(currentUserId);

    // Cerrar menús al navegar
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.isMenuOpen = false;
        this.isGestionMenuOpen = false;
      });
  }

  toggleMenu() {
    this.isMenuOpen = !this.isMenuOpen;
    if (this.isMenuOpen) {
      this.isGestionMenuOpen = false;
    }
  }

  toggleGestionMenu() {
    this.isGestionMenuOpen = !this.isGestionMenuOpen;
    if (this.isGestionMenuOpen) {
      this.isMenuOpen = false;
    }
  }

  navigateToGestion(route: string, filter?: string | null) {
    this.isGestionMenuOpen = false;
    if (filter) {
      this.router.navigate([route], { queryParams: { filter } });
    } else {
      this.router.navigate([route]);
    }
  }

  logOut() {
    // Aquí irá la lógica de cierre de sesión
    this.router.navigate(['/login']);
  }

}
